import { colors } from '@akin-home/theme';
import { useEffect } from 'react';
import Animated, {
  Easing,
  Extrapolate,
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';
import styled from 'styled-components/native';

interface PulseProps {
  delay?: number;

  repeat?: boolean;

  size?: number;
}

export function PulseEffect(props: { size?: number }) {
  return (
    <>
      <Pulse size={props.size} delay={1000} repeat />
      <Pulse size={props.size} delay={800} repeat />
      <Pulse size={props.size} delay={400} repeat />
      <Pulse size={props.size} delay={200} repeat />
      <Pulse size={props.size} repeat />
    </>
  );
}

const Pulse = ({ delay = 0, repeat, size = 200 }: PulseProps) => {
  const animation = useSharedValue(0);

  useEffect(() => {
    animation.value = withDelay(
      delay,
      withRepeat(
        withTiming(1, {
          duration: 2000,
          easing: Easing.linear,
        }),
        repeat ? -1 : 1,
        false
      )
    );
  }, []);

  const animatedStyles = useAnimatedStyle(() => {
    const opacity = interpolate(
      animation.value,
      [0, 1],
      [0.6, 0],
      Extrapolate.CLAMP
    );
    return {
      opacity: opacity,
      transform: [{ scale: animation.value }],
    };
  });

  return <Circle size={size} style={[animatedStyles]} />;
};

const Circle = styled(Animated.View)<{ size?: number }>(({ size = 200 }) => ({
  width: size,
  height: size,
  borderRadius: size / 2,
  borderColor: colors.primary[50],
  borderWidth: 2,
  backgroundColor: colors.primary[700],
  position: 'absolute',
}));
